import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CategorieSelect from './CategorieSelect';
import { fetchCategories } from 'store/categorie/categorieActions';

class CategorieSelectContainer extends React.Component {
    componentDidMount() {
        this.props.fetchCategories();
    }

    render() {
        const { categories, typeId, value, isLoading, onChange, error, isRequired, afficheAide, autoFocus, disabled } = this.props;


        let filteredCategories = categories.filter(q => q.typeId === typeId);

        return (
            <CategorieSelect
                categories={filteredCategories}
                value={value}
                isLoading={isLoading}
                onChange={onChange}
                error={error}
                isRequired={isRequired}
                afficheAide={afficheAide}
                autoFocus={autoFocus}
                disabled={disabled}
            />
        );
    }
}

const mapStateToProps = state => ({
    categories: state.categorie.categories.items,
    isLoading: state.categorie.categories.isLoading
});

const mapDispatchToProps = dispatch => ({
    fetchCategories: () => dispatch(fetchCategories())
});

CategorieSelectContainer.propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    typeId: PropTypes.number.isRequired,
    isRequired: PropTypes.bool.isRequired,
    afficheAide: PropTypes.bool,
    error: PropTypes.object,

    autoFocus: PropTypes.bool,
    disabled: PropTypes.bool,
    
};


CategorieSelectContainer.defaultProps = {
    afficheAide: false,
    autoFocus: false,
    disabled: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(CategorieSelectContainer);